//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
	mapMutations
} from "vuex";
import { sessionLogin } from "@/api";
import Cookies from "@/utils/cookie";
export default {
  data() {
    return {
      phone: "",
      password: "",
    };
  },
  methods: {
		...mapMutations([
			"setloginModal",
			"setPayModal",
			"setInfo",
			"getboxList",
			"RequestTradeOffer",
			"setBannerList",
			"setNoticeList",
		]),    
    login() {
      if (this.phone.trim().length != 0 && this.password.trim().length != 0) {
        this.Sign();
      } else {
        this.message("用户名或密码不能为空！");
      }
    },
    async Sign() {
      sessionLogin({ username: this.phone, password : this.password }).then( async (res) => {
        if (res.data.code === 0) {

          Cookies.setToken(res.data.authToken);
          this.$toast.success("登陆成功");

          this.setInfo();
          this.getboxList();
          this.RequestTradeOffer();

          await this.$caseBattleHub.conn.stop(); //登录后重置hub连接状态
          await this.$caseBattleHub.conn.start();

          this.close();
        } else {
          this.$toast.error(res.data.msg);
        }
      });
    },
    close() {
      this.$store.commit("set_logpopShow", false);
    },
  },
};
